import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Popularcommunitytypes.css";
import analyticsService from "../../services/analyticsService";

import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";

import BookingIcon from "../assets/img/Booklead.svg";
import Searchh from "../assets/img/Searchh.svg";
import TotalVilla from "../assets/img/TotalVilla.svg";
import LeadIcon from "../assets/img/registerlead.svg";

import Villa from "../assets/img/Villa11.svg";
import Apartment from "../assets/img/Apartment11.svg";
import PlotIcon from "../assets/img/Plot11.svg";
import arrowleftt from "../assets/img/arrowleftt.svg"

// Community type icon mapping (matches React Native app)
const COMMUNITY_TYPE_ICONS = {
  gated: Villa,
  'semi-gated': Apartment,
  standalone: PlotIcon,
  'semi_gated': Apartment,
  default: Villa,
};

export default function PopularCommunityTypes() {
  const navigate = useNavigate();
  // EXACT React Native app state structure
  const [loading, setLoading] = useState(true);
  const [communityTypes, setCommunityTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [citiesByState, setCitiesByState] = useState({});
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  // Load states and cities on component mount
  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);

      // Load states and cities first
      const citiesStatesResponse = await analyticsService.getCitiesAndStates();
      if (citiesStatesResponse.success && citiesStatesResponse.data) {
        setStates([...new Set((citiesStatesResponse.data.states || []).map(s => s.replace(/\s+\d{5,6}\s*$/, '').trim()))].sort());
        setCitiesByState(citiesStatesResponse.data.citiesByState || {});
      }

      await loadCommunityTypes();
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadCommunityTypes = async (pageNum = 1) => {
    try {
      const filters = { page: pageNum, per_page: 20 };
      if (selectedCity) filters.city = selectedCity;
      if (selectedState) filters.state = selectedState;

      const response = await analyticsService.getPopularCommunityTypes(filters);

      if (response.success && response.data) {
        setCommunityTypes(response.data.items || []);
        setTotal(response.data.total || 0);
        setTotalPages(response.data.total_pages || 1);
        setPage(pageNum);
      } else {
        setCommunityTypes([]);
        setTotal(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error('Error loading community types:', error);
      setCommunityTypes([]);
      setTotal(0);
      setTotalPages(1);
    }
  };

  const handleApply = async () => {
    setLoading(true);
    setPage(1); // Reset to first page when applying filters
    await loadCommunityTypes(1);
    setLoading(false);
  };

  const handleStateChange = (e) => { setSelectedState(e.target.value); setSelectedCity(''); };
  const handleCityChange = (e) => { setSelectedCity(e.target.value); };
  const getFilteredCities = () => !selectedState ? [] : (citiesByState[selectedState] || []);

  // Format community type name (matches React Native app)
  const formatTypeName = (type) => {
    if (!type) return 'Unknown';
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  // Get community type icon (matches React Native app)
  const getTypeIcon = (type) => {
    return COMMUNITY_TYPE_ICONS[type?.toLowerCase()] || COMMUNITY_TYPE_ICONS.default;
  };

  return (
    <div className="pct-page d-flex">
      <LeftNav />

      <div className="pct-content-wrap flex-grow-1">
        <TopNav />

        <div className="container-fluid">
          <div className="pct-card card pct-container-card mt-3">
            <div className="card-body">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-start pct-header-row">
                <div className="d-flex align-items-center gap-2 pct-header-left">
                 <img src={arrowleftt} onClick={() => navigate("/webadmindashboard")} style={{cursor: "pointer"}}></img>
                  <h2 className="pct-page-title mb-0">Popular Community Types</h2>
                </div>

                <div className="d-flex gap-2 align-items-end pct-filters">
                  <div className="d-flex flex-column">
                    <label className="pct-label">State</label>
                    <select
                      className="form-select form-select-sm pct-select"
                      value={selectedState}
                      onChange={handleStateChange}
                      disabled={loading}
                    >
                      <option value="">Select State</option>
                      {Array.isArray(states) ? states.map((state, idx) => (
                        <option key={idx} value={state}>{state}</option>
                      )) : []}
                    </select>
                  </div>

                  {selectedState && (
                    <div className="d-flex flex-column">
                      <label className="pct-label">City</label>
                      <select
                        className="form-select form-select-sm pct-select"
                        value={selectedCity}
                        onChange={handleCityChange}
                        disabled={loading}
                      >
                        <option value="">Select City</option>
                        {getFilteredCities().map((city, idx) => (
                          <option key={idx} value={city}>{city}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <button
                    className="btn btn-primary pct-apply-btn"
                    onClick={handleApply}
                    disabled={loading}
                  >
                    {loading ? 'Loading...' : 'Apply'}
                  </button>
                </div>
              </div>

              {/* Loading State */}
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                </div>
              ) : communityTypes.length === 0 ? (
                <div className="pct-empty-container">
                  <p>No community types found</p>
                  <button onClick={handleApply} className="pct-retry-btn">Retry</button>
                </div>
              ) : (
                <>
                  {/* Items grid (2 columns) */}
                  <div className="pct-grid mt-3">
                    {communityTypes.map((communityType, idx) => {
                      const typeName = formatTypeName(communityType.community_type);
                      const rank = (page - 1) * 20 + idx + 1;

                      return (
                        <div key={`${communityType.community_type}-${idx}`} className="pct-item-card card">
                          <div className="card-body pct-item-body">
                            <div className="d-flex">
                              <div className="pct-main flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="pct-title d-flex align-items-center">
                                    <span className="pct-type">{rank} Community Type:</span>
                                    <span className="pct-type-name ms-1">{typeName}</span>
                                    <img src={getTypeIcon(communityType.community_type)} alt={typeName} className="pct-type-icon ms-2" />
                                  </div>
                                </div>

                                <div className="pct-borderline"></div>

                                {/* 2x2 stat grid */}
                                <ul className="pct-meta-grid list-unstyled mb-0">
                                  <li className="pct-meta-cell">
                                    <div className="pct-meta-left">
                                      <img src={BookingIcon} alt="Bookings" className="pct-meta-icon" />
                                      <span className="pct-meta-text">Total Bookings:</span>
                                    </div>
                                    <div className="pct-meta-right">
                                      <span className="pct-meta-value">{communityType.total_bookings || 0}</span>
                                    </div>
                                  </li>

                                  <li className="pct-meta-cell">
                                    <div className="pct-meta-left">
                                      <img src={Searchh} alt="Searches" className="pct-meta-icon" />
                                      <span className="pct-meta-text">Searches:</span>
                                    </div>
                                    <div className="pct-meta-right">
                                      <span className="pct-meta-value">{communityType.searches || 0}</span>
                                    </div>
                                  </li>

                                  <li className="pct-meta-cell">
                                    <div className="pct-meta-left">
                                      <img src={LeadIcon} alt="Leads" className="pct-meta-icon" />
                                      <span className="pct-meta-text">Registered Leads:</span>
                                    </div>
                                    <div className="pct-meta-right">
                                      <span className="pct-meta-value">{communityType.registered_leads || 0}</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Pagination (EXACT React Native app logic) */}
                  {totalPages > 1 && (
                    <div className="pct-pagination">
                      <button
                        className={`pct-page-btn ${page <= 1 ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page > 1 && !loading) {
                            setLoading(true);
                            try {
                              await loadCommunityTypes(page - 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page <= 1 || loading}
                      >
                        ← Previous
                      </button>

                      <span className="pct-page-info">
                        Page {page} of {totalPages} ({total} total)
                      </span>

                      <button
                        className={`pct-page-btn ${page >= totalPages ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page < totalPages && !loading) {
                            setLoading(true);
                            try {
                              await loadCommunityTypes(page + 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page >= totalPages || loading}
                      >
                        Next →
                      </button>
                    </div>
                  )}
                </>
              )}

            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
